module.exports = __webpack_public_path__ + "posture/static/img/wechatShare.767acb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/wechatShare.png
// module id = ePlP
// module chunks = 1